import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { Text, TextLink } from '@frontend/design-system';

export const AddCustomDetails = () => {
  const { t } = useTranslation('ai-receptionist-settings');
  const { navigate } = useSettingsNavigate();

  return (
    <div css={styles.container}>
      <Text>{t('Add Custom Details')}</Text>
      <TextLink onClick={() => navigate({ to: '/ai-configuration/ai-receptionist/knowledge-base/custom' })}>
        {t('Go To Custom Knowledge')}
      </TextLink>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--fabric-space-padding-xs);
    border: var(--fabric-border-width-thin) solid var(--fabric-color-accent-neutral-muted);
    border-radius: var(--fabric-radius-md);
    background-color: var(--fabric-color-surface-default);
  `,
};
